export default {
    resetAll: () => ({type: 'ONCE_RESET_ALL'}),
    reset: collection => ({type: 'ONCE_RESET_COLLECTION', collection}),
    touch: (collection, id) => ({type: 'ONCE_TOUCH', collection, id}),
};
